import { WebsiteModule } from '@/interfaces/module.interface';
import { ApiQueryParams, apiRequest } from '../Api';

export interface UpdateWebsiteModuleResponse {
  success: boolean;
  message: string;
  data: { id: string };
  execution_time: number;
  cached: boolean;
  timestamp: string;
}

export const updateWebsiteModule = (
  moduleId: string,
  params: ApiQueryParams,
  data: Partial<WebsiteModule>
) =>
  apiRequest<Partial<WebsiteModule>, UpdateWebsiteModuleResponse>({
    url: `/entities/update/${moduleId}`,
    scope: 'module',
    method: 'PUT',
    params,
    data: { data },
  });

